import { Widget } from "@foretagsplatsen/widgetjs";
import CancellingWizardHeaderWidget from "../CancellingWizardHeaderWidget/CancellingWizardHeaderWidget.js";
import RoadmapWidget from "../../widgets/RoadmapWidget/RoadmapWidget.js";
import WizardWidget from "../WizardWidget.js";

/**
 * Widget gluing together a Wizard and a Roadmap of the wizard's step.
 * We assume that the wizard has all its steps already.
 *
 * @param {Renderable} title - Title of the WizardWidget
 * @param {Renderable} [description] - Description of the WizardWidget
 * @param {wizard} wizard - A wizard with steps
 * @param {Renderable} [loader] - When provided, this will be rendered before the wizard
 *   is started, in place of the step content
 */
export default class WizardWithRoadmap extends Widget {
	constructor({ title, description, wizard, loader }) {
		super(...arguments);

		this._roadmap = RoadmapWidget.forWizard({ wizard });

		wizard.getSteps().forEach((step) => {
			step?.setLeftWidget(this._roadmap);
		});

		this._wizardWidget = new WizardWidget({
			loader,
			header: new CancellingWizardHeaderWidget({
				wizard,
				title,
				description,
			}),
			wizard,
		});
	}

	renderContentOn(html) {
		html.div({ class: "WizardWithRoadmap" }, this._wizardWidget);
	}
}
